// Collection metadata for Ménage KGD
// Official isolated logo (transparent background)
export const OFFICIAL_LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_collections-kgd-app/artifacts/97facs7n_BBA5FAAA-893B-4983-B52F-F3A28D3DB42A.png";

// Reference posters — MATCHED EXACTLY to their collection (verified visually)
export const POSTERS = {
    ensemble: "https://customer-assets-7cd3h4nn.emergentagent.net/job_add5d42c-32c1-4074-a1bb-1bf5ff7187c6/artifacts/gwwgovj7_850149E8-0E05-4C02-B516-4FDA06694A8B.png",
    emeraude: "https://customer-assets-7cd3h4nn.emergentagent.net/job_add5d42c-32c1-4074-a1bb-1bf5ff7187c6/artifacts/bbzrc5mx_CECA28E1-E42E-4792-92A5-0B9D13374EAC.png",
    rubis:    "https://customer-assets-7cd3h4nn.emergentagent.net/job_add5d42c-32c1-4074-a1bb-1bf5ff7187c6/artifacts/wdlzq1xd_3EC99677-9638-49E8-ACB9-206C853EE798.png",
    perle:    "https://customer-assets-7cd3h4nn.emergentagent.net/job_add5d42c-32c1-4074-a1bb-1bf5ff7187c6/artifacts/abkgxt10_4C48BDC4-C1D8-4F2C-A286-441BE94C338B.png",
    saphir:   "https://customer-assets-7cd3h4nn.emergentagent.net/job_add5d42c-32c1-4074-a1bb-1bf5ff7187c6/artifacts/oeo8kxo6_7C7C7390-BDA7-45EB-B73E-99B4A6C7F525.png",
    diamant:  "https://customer-assets-jt897jd0.emergentagent.net/job_collections-kgd-app/artifacts/wsl1bpfu_1EDF1457-D38E-45D8-A8D8-487C30E6783E.png",
};

// Diamant now has its own official poster
export const DIAMANT_HERO = POSTERS.diamant;

export const HERO_INTERIOR = "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4ODcwMDAwMHww&ixlib=rb-4.1.0&q=85";

export const COLLECTIONS = [
    {
        slug: "emeraude",
        name: "Émeraude",
        subtitle: "Entretien régulier résidentiel",
        emotional: "Préserver l'éclat de votre maison, semaine après semaine.",
        verb: "Préserver",
        forWhom: "Familles, professionnels occupés, résidences déjà entretenues régulièrement, clients recherchant de la constance et une routine bien établie.",
        experience: [
            { t: "Cuisine",       d: "Surfaces, comptoirs, extérieurs des électroménagers." },
            { t: "Salles de bain", d: "Assainissement complet, robinetterie, miroirs et céramique." },
            { t: "Poussière",     d: "Meubles, cadres, plinthes accessibles et surfaces exposées." },
            { t: "Surfaces",      d: "Éclat des surfaces vitrées et polies convenues." },
            { t: "Planchers",     d: "Aspirateur et lavage selon les revêtements." },
            { t: "Espaces convenus", d: "Chaque pièce est traitée selon le plan défini à l'évaluation." },
        ],
        investment: "À partir de 120 $ + taxes / visite",
        investmentNote: "Votre entretien selon la fréquence choisie",
        tagline: "La Collection Émeraude est conçue pour l'entretien régulier de votre résidence. Elle permet de maintenir une maison propre, agréable et constante, selon une fréquence adaptée à votre quotidien.",
        primary: "#138A3D",
        accent: "#0F5132",
        soft: "#F0FDF4",
        border: "#138A3D",
        poster: POSTERS.emeraude,
        posterFit: "cover",
        stoneStory: {
            title: "Pourquoi l'Émeraude ?",
            keywords: ["fraîcheur", "renouveau", "équilibre"],
            text: "Chez Ménage KGD, l'émeraude représente la {kw:fraîcheur}, le {kw:renouveau} et l'{kw:équilibre}. C'est l'image parfaite d'un intérieur entretenu avec constance, où la propreté se maintient naturellement au fil des visites.",
            finalPhrase: "Émeraude, c'est la tranquillité de retrouver un espace propre, encore et encore.",
        },
        features: [
            "Entretien hebdomadaire",
            "Toutes les deux semaines",
            "Toutes les trois semaines",
            "Entretien mensuel",
            "Tâches adaptées aux besoins du domicile",
            "Produits fournis ou utilisation des produits du client, selon l'entente",
        ],
    },
    {
        slug: "rubis",
        name: "Rubis",
        subtitle: "Grand ménage • Remise à niveau • Après construction",
        emotional: "Transformer un espace qui demande plus qu'un simple entretien.",
        verb: "Transformer",
        forWhom: "Espaces après construction ou rénovation, remises à niveau, emménagements, déménagements, résidences ou locaux nécessitant une intervention en profondeur.",
        experience: [
            { t: "Diagnostic sur place",    d: "Analyse minutieuse de l'état des lieux avant l'intervention." },
            { t: "Grand ménage profondeur", d: "Traitement complet des surfaces, planchers et éléments accessibles." },
            { t: "Poussières de chantier",  d: "Élimination méthodique des résidus après construction/rénovation." },
            { t: "Détails oubliés",         d: "Plinthes, luminaires, cadrages, coins, angles et recoins." },
            { t: "Éclat des surfaces",      d: "Finition soignée qui redonne son éclat à chaque pièce." },
            { t: "Reprise finale",          d: "Contrôle qualité complet avant de quitter les lieux." },
        ],
        investment: "Sur évaluation personnalisée",
        investmentNote: "Selon l'état des lieux et l'ampleur du mandat",
        tagline: "La Collection Rubis est conçue pour les interventions plus intensives — grand ménage, remise à niveau, nettoyage après construction ou travaux, emménagement/déménagement. Une intervention minutieuse qui remet l'espace dans un état propre, sain et éclatant.",
        primary: "#D90429",
        accent: "#8B0000",
        soft: "#FFF1F2",
        border: "#8B0000",
        poster: POSTERS.rubis,
        posterFit: "cover",
        stoneStory: {
            title: "Pourquoi le Rubis ?",
            keywords: ["force", "intensité", "transformation"],
            text: "Le rubis incarne la {kw:force}, l'{kw:intensité} et la {kw:transformation}. Il représente les interventions où un simple entretien ne suffit plus : grand ménage, remise à niveau, emménagement ou après-construction.",
            finalPhrase: "Rubis, c'est redonner de l'éclat à un espace qui a besoin de plus.",
        },
        features: [
            "Grand ménage en profondeur",
            "Remise à niveau complète",
            "Nettoyage après construction",
            "Nettoyage après rénovation ou travaux",
            "Emménagement et déménagement",
            "Remise en état approfondie",
            "Besoins particuliers sur évaluation",
        ],
    },
    {
        slug: "perle",
        name: "Perle",
        subtitle: "Les attentions qui font toute la différence.",
        emotional: "Les attentions supplémentaires qui rendent votre entretien unique.",
        verb: "Personnaliser",
        forWhom: "Clients d'une Collection Émeraude, Diamant ou Saphir souhaitant compléter leur entretien avec des attentions ciblées.",
        experience: [
            { t: "Cuisine ciblée",   d: "Intérieur du four, du réfrigérateur et des armoires selon vos besoins." },
            { t: "Surfaces vitrées", d: "Fenêtres intérieures et extérieures accessibles." },
            { t: "Espaces additionnels", d: "Sous-sol, chambres supplémentaires, pièces spécifiques." },
            { t: "Organisation légère", d: "Pliage et rangement complémentaires pour finir l'expérience." },
            { t: "Sur mesure",       d: "Demandes personnalisées analysées à l'évaluation." },
        ],
        investment: "Options à partir de 35 $",
        investmentNote: "Composez selon vos besoins",
        tagline: "Des services complémentaires à sélectionner selon vos besoins, pour aller au-delà de l'entretien régulier et prendre soin des détails de votre espace.",
        primary: "#B8912B",
        accent: "#8C6D1F",
        soft: "#FAF8F1",
        border: "#B8912B",
        poster: POSTERS.perle,
        posterFit: "cover",
        stoneStory: {
            title: "Pourquoi la Perle ?",
            keywords: ["finesse", "simplicité", "attention"],
            text: "La perle symbolise la {kw:finesse}, la {kw:simplicité} et l'{kw:attention} portée aux détails. Cette Collection a été pensée pour les besoins précis qui ne nécessitent pas forcément un entretien complet : vitres, électroménagers, armoires et autres services ciblés.",
            finalPhrase: "Perle, c'est choisir exactement l'attention dont votre espace a besoin.",
        },
        features: [
            "Salle de bain complète",
            "Cuisine complète",
            "Intérieur du four",
            "Intérieur du réfrigérateur",
            "Vitres intérieures",
            "Intérieur des armoires",
            "Plinthes",
            "Luminaires accessibles",
            "Demandes personnalisées",
        ],
    },
    {
        slug: "saphir",
        name: "Saphir",
        subtitle: "Entretien commercial",
        emotional: "Un environnement qui reflète le sérieux de votre entreprise.",
        verb: "Représenter",
        forWhom: "Bureaux, commerces, PME, cliniques, concessionnaires et espaces professionnels dont l'image dépend d'un environnement impeccable et constant.",
        experience: [
            { t: "Analyse de l'espace",  d: "Compréhension de vos flux, horaires et zones sensibles." },
            { t: "Plan d'entretien",     d: "Fréquence, tâches et priorités définies selon vos exigences." },
            { t: "Zones critiques",      d: "Accueil, salles de conférence, sanitaires, aires communes." },
            { t: "Discrétion",           d: "Équipe formée à l'environnement professionnel et à la confidentialité." },
            { t: "Constance mesurable",  d: "Un standard maintenu semaine après semaine, sans variation." },
            { t: "Communication claire", d: "Suivi structuré, ajustements et rapports périodiques." },
        ],
        investment: "Plan d'entretien personnalisé — sur évaluation",
        investmentNote: "Bureaux, commerces, cliniques, PME",
        tagline: "Des espaces professionnels propres, constants et rassurants qui soutiennent votre image d'entreprise.",
        primary: "#075BC8",
        accent: "#041126",
        soft: "#F0F7FF",
        border: "#075BC8",
        poster: POSTERS.saphir,
        posterFit: "cover",
        stoneStory: {
            title: "Pourquoi le Saphir ?",
            keywords: ["confiance", "constance", "professionnalisme"],
            text: "Le saphir représente pour nous la {kw:confiance}, la {kw:constance} et le {kw:professionnalisme}. Des qualités essentielles lorsqu'une entreprise nous confie l'entretien de ses espaces, de son image et du confort de ceux qui les fréquentent.",
            finalPhrase: "Saphir, c'est un partenariat fondé sur la fiabilité.",
        },
        features: [
            "Bureaux",
            "Commerces et PME",
            "Cliniques",
            "Concessionnaires",
            "Espaces communs",
            "Entretien régulier et structuré",
            "Service fiable et discret",
            "Plan d'entretien personnalisé",
        ],
    },
    {
        slug: "diamant",
        name: "Diamant",
        subtitle: "Résidentiel premium",
        emotional: "Élever votre niveau de confort avec une attention supérieure.",
        verb: "Élever",
        forWhom: "Résidences de grande superficie ou clients recherchant un niveau d'attention supérieur, une prise en charge complète et une constance irréprochable.",
        experience: [
            { t: "Prise en charge complète", d: "Une équipe attentive à chaque détail de votre résidence." },
            { t: "Attention aux détails",    d: "Un niveau d'exigence supérieur, jamais laissé au hasard." },
            { t: "Constance exemplaire",     d: "La même qualité, visite après visite, sans variation." },
            { t: "Rythmes ajustés",          d: "Fréquence et durée alignées avec votre quotidien." },
            { t: "Expérience soignée",       d: "Une équipe stable, discrète et respectueuse de votre univers." },
            { t: "Tranquillité totale",      d: "Rien à superviser — nous prenons soin de tout." },
        ],
        investment: "Service personnalisé — sur évaluation",
        investmentNote: "Investissement déterminé selon votre résidence",
        tagline: "La Collection Diamant s'adresse aux clients recherchant une prise en charge plus complète, une attention accrue aux détails et un niveau d'entretien supérieur.",
        primary: "#7DD3FC",
        accent: "#0369A1",
        soft: "#F0FAFF",
        border: "#7DD3FC",
        poster: DIAMANT_HERO,
        posterFit: "cover",
        stoneStory: {
            title: "Pourquoi le Diamant ?",
            keywords: ["excellence", "précision", "éclat"],
            text: "Le diamant évoque l'{kw:excellence}, la {kw:précision} et l'{kw:éclat}. Nous l'avons choisi pour notre Collection la plus exigeante, destinée aux espaces où chaque détail compte et où le niveau de finition doit rester impeccable.",
            finalPhrase: "Diamant, c'est notre standard le plus élevé.",
        },
        features: [
            "Entretien de résidences plus vastes",
            "Service personnalisé",
            "Attention particulière aux détails",
            "Constance d'une visite à l'autre",
            "Expérience rassurante et soignée",
            "Tranquillité d'esprit",
        ],
    },
];

// Perle add-on options (à partir de prices, elegant catalog)
export const PERLE_OPTIONS = [
    { key: "frigo",    label: "Réfrigérateur",                        desc: "Nettoyage intérieur approfondi.",                                                       from: "35 $" },
    { key: "four",     label: "Four",                                 desc: "Nettoyage intérieur et dégraissage.",                                                    from: "65 $" },
    { key: "fenetres", label: "Fenêtres intérieures et extérieures",  desc: "Nettoyage des surfaces vitrées accessibles selon la configuration des lieux.",           from: "125 $" },
    { key: "sous-sol", label: "Sous-sol",                             desc: "Ajout de l'entretien d'un espace supplémentaire.",                                       from: "45 $" },
    { key: "pliage",   label: "Pliage / organisation légère",         desc: "Service complémentaire selon les besoins.",                                              from: "45 $" },
    { key: "espaces",  label: "Chambres ou espaces supplémentaires",  desc: "Ajout d'espaces à votre entretien régulier.",                                            from: "Sur évaluation" },
];

export const INVESTMENT_LEVELS = [
    { key: "120-150",  label: "120 $ à 150 $ / visite" },
    { key: "150-200",  label: "150 $ à 200 $ / visite" },
    { key: "200-300",  label: "200 $ à 300 $ / visite" },
    { key: "300+",     label: "300 $ et plus / visite" },
    { key: "conseil",  label: "Je souhaite être conseillé(e)" },
];

export const getCollection = (slug) => COLLECTIONS.find(c => c.slug === slug);

export const SERVICE_AREAS = [
    "Trois-Rivières",
    "Shawinigan",
    "Bécancour",
    "Nicolet",
    "Cap-de-la-Madeleine",
    "Grand-Mère",
    "Louiseville",
    "Yamachiche",
    "Champlain",
    "Batiscan",
    "Sainte-Anne-de-la-Pérade",
    "Mauricie et environs",
];

export const STATUSES = [
    { key: "nouveau_lead", label: "Nouveau lead", color: "#075BC8" },
    { key: "contact_etabli", label: "Contact établi", color: "#138A3D" },
    { key: "evaluation_planifiee", label: "Évaluation planifiée", color: "#D4AF37" },
    { key: "soumission_a_preparer", label: "Soumission à préparer", color: "#8C6D1F" },
    { key: "soumission_envoyee", label: "Soumission envoyée", color: "#0369A1" },
    { key: "relance", label: "Relance", color: "#D97706" },
    { key: "gagne", label: "Gagné", color: "#059669" },
    { key: "perdu", label: "Perdu", color: "#DC2626" },
];
